import busdToken from "../abis/busdToken";

const host = "https://bscscan.com/address/";

export default {
  title: "BUSD",
  contractAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
  abi: busdToken.abi,
  url: `${host}/0xe9e7cea3dedca5984780bafc599bd69add087d56`,
  decimals: 18,
};
